export const FULL_NAME_MAX_CHARACTERS: number = 100;
export const QUICK_ACCESS_CODE_MAX_CHARACTERS: number = 4;
export const DISPLAY_NAME_MAX_CHARACTERS: number = 20;
export const ROOM_NAME_MAX_CHARACTERS: number = 15;
export const MEDIA_DESCRIPTION_MAX_CHARACTERS: number = 250;
export const CUSTOM_NAME_MAX_CHARACTERS: number = 20;
export const PROCESS_NUMBER_MAX_CHARACTERS: number = 30;
export const RECURRING_FEE_MAX_CHARACTERS: number = 10;
export const ADITIONAL_INFO_MAX_CHARACTERS: number = 1_000;
export const NATIONAL_ID_MAX_CHARACTERS: number = 20;
export const CAREPLAN_TASKS_FIELD = {
  FEATURE: {
    NOTES: 500,
  },
};

export const ROLES_MAX_CHARACTERS = {
  name: 40,
  description: 120,
};
